import { FacilityDTO } from "../facilities/Facility";
import { RoleDTO } from "../roles/Role";
import { AccountDTO, AccountRelatedDTO } from "./Account";
import { AccountUserDTO } from "./AccountUser";

export class AvailableAccount {
  private _accountDTO?: AccountDTO;
  constructor(
    private _accountRelatedDTO: AccountRelatedDTO,
    private _accountUserDTO?: AccountUserDTO,
  ) {
    if (this._accountUserDTO) {
      this._accountDTO = this._accountUserDTO.account;
    }
  }

  get accountID() {
    return this._accountRelatedDTO?.id;
  }

  get accountUserID() {
    return this._accountUserDTO?.id;
  }

  get name() {
    return this.accountRelatedDTO.name;
  }

  get catalog() {
    return this.accountRelatedDTO.catalog;
  }

  get role(): RoleDTO | undefined {
    return this._accountUserDTO?.role;
  }

  set role(value) {
    if (this._accountUserDTO) {
      this._accountUserDTO.role = value!;
    }
  }

  get availableRoles(): RoleDTO[] {
    return this.accountRelatedDTO.roles;
  }

  set availableRoles(value: RoleDTO[]) {
    this.accountRelatedDTO.roles = value;
  }

  get apps() {
    return this._accountRelatedDTO.apps;
  }

  set apps(value) {
    this._accountRelatedDTO.apps = value;
  }

  get roleID() {
    return this._accountUserDTO?.role_id;
  }

  get preferences() {
    return this._accountUserDTO?.preferences;
  }

  get profile() {
    return this._accountUserDTO?.profile;
  }

  get facilities() {
    return this._accountRelatedDTO.facilities;
  }

  set facilities(value: FacilityDTO[]) {
    this._accountRelatedDTO.facilities = value;
  }

  get groups() {
    return this._accountRelatedDTO?.accountUserGroups;
  }

  set groups(value) {
    this._accountRelatedDTO!.accountUserGroups = value;
  }

  get accountDTO() {
    return this._accountDTO;
  }

  get accountRelatedDTO() {
    return this._accountRelatedDTO;
  }

  get accountUserDTO() {
    return this._accountUserDTO;
  }

  get features() {
    return this._accountRelatedDTO.features;
  }
}
